export default __webpack_public_path__ + "static/media/35_B.b5fb38c3.svg";